import styled from "styled-components";

import { COLORS } from "../../../constants/Styles";

const Checkbox = styled.div<{ checked: boolean; disabled: boolean }>`
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  filter: ${({ disabled }) => (disabled ? "brightness(50%)" : "default")};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%),
    ${COLORS.tableBackground};
  width: 16px;
  height: 16px;
  margin-right: 0.25rem;
`;

const Container = styled.div<{ disabled: boolean }>`
  display: flex;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};

  > span {
    margin-left: 0.25rem;
    cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  }
`;

export { Checkbox, Container };
